export function sortChipItems(items, mode) {
  const copy = items.slice();
  if (mode === 'count') {
    copy.sort((a, b) => b.count - a.count || a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }));
  } else {
    copy.sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }));
  }
  return copy;
}

export function visibleLimitForCollapse() {
  return 12;
}

export function planCollapsedVisibility(total, limit, collapsed) {
  return Array.from({ length: total }, (_, i) => Boolean(collapsed && i >= limit));
}

export function applyChipOrder(container, mode, collapsed) {
  const chips = Array.from(container.querySelectorAll('.collection-taxonomy__chip'));
  const items = chips.map((el) => ({
    el,
    title: el.dataset.title || el.textContent.trim(),
    count: Number(el.dataset.count || 0),
  }));
  const ordered = sortChipItems(items, mode);
  const limit = visibleLimitForCollapse();
  const hiddenFlags = planCollapsedVisibility(ordered.length, limit, collapsed);
  ordered.forEach((item, index) => {
    const row = item.el.closest('li') || item.el;
    container.appendChild(row);
    row.hidden = hiddenFlags[index];
  });
  return ordered.length;
}

export function initCollectionTaxonomy(root = document) {
  root.querySelectorAll('[data-taxonomy-chips]').forEach((container) => {
    if (container.dataset.taxonomyInitialized === 'true') return;
    container.dataset.taxonomyInitialized = 'true';

    const button = container.parentElement?.querySelector('[data-taxonomy-expand]');
    let collapsed = true;
    const sync = () => {
      const total = applyChipOrder(container, collapsed ? 'count' : 'title', collapsed);
      if (!button) return;
      const limit = visibleLimitForCollapse();
      const extra = Math.max(0, total - limit);
      if (total <= limit) {
        button.hidden = true;
        return;
      }
      button.hidden = false;
      button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      button.textContent = collapsed
        ? (button.dataset.labelMore || '').replace('__COUNT__', String(extra))
        : button.dataset.labelLess;
    };
    sync();
    button?.addEventListener('click', () => {
      collapsed = !collapsed;
      sync();
    });
  });
}

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => initCollectionTaxonomy());
  document.addEventListener('shopify:section:load', (event) => {
    initCollectionTaxonomy(event.target);
  });
}
